import { HISTORICAL_DATA } from '../../data/historicalData';
import { RAMADAN_DATES } from '../../data/ramadanDates';
import styles from './OnThisDay.module.css';

export default function OnThisDay({ onSelect }) {
  const today = new Date();

  const currentYear = Object.keys(RAMADAN_DATES).find(year => {
    const start = new Date(RAMADAN_DATES[year].start);
    const end = new Date(RAMADAN_DATES[year].end);
    return today >= start && today <= end;
  });

  if (!currentYear) return null;

  const dayOfRamadan = Math.floor((today - new Date(RAMADAN_DATES[currentYear].start)) / 86400000) + 1;

  const items = Object.keys(HISTORICAL_DATA)
    .filter(year => RAMADAN_DATES[year])
    .map(year => {
      const yearStart = new Date(RAMADAN_DATES[year].start);
      const equivalentDate = new Date(yearStart);
      equivalentDate.setDate(yearStart.getDate() + dayOfRamadan - 1);
      const content = [...(HISTORICAL_DATA[year].shows || []), ...(HISTORICAL_DATA[year].series || [])][0];
      return { year: parseInt(year), date: equivalentDate.toLocaleDateString('en-US', {month:'long',day:'numeric'}), content };
    })
    .filter(item => item.content)
    .sort((a, b) => b.year - a.year);

  if (!items.length) return null;

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>🌙 On this day — Day {dayOfRamadan} of Ramadan</h2>
      <div className={styles.row}>
        {items.map(({ year, date, content }) => (
          <div key={year} className={styles.card} onClick={() => onSelect && onSelect({...content, suppressTrailer: true})}>
            <div className={styles.year}>{year}</div>
            <div className={styles.date}>{date}</div>
            <div className={styles.title}>{content.title}</div>
            {content.titleEn && <div className={styles.en}>{content.titleEn}</div>}
          </div>
        ))}
      </div>
    </section>
  );
}
